"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSnackbarProviderProps = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const notistack_1 = require("notistack");
const defaultSnackbarProviderProps = (props) => ({
    maxSnack: 10,
    preventDuplicate: true,
    ...props,
    anchorOrigin: {
        horizontal: "right",
        vertical: "top",
        ...(props.anchorOrigin ? props.anchorOrigin : {}),
    },
});
exports.defaultSnackbarProviderProps = defaultSnackbarProviderProps;
/**
 *
 * @category component
 */
const SnackbarProvider = (props) => {
    const providerProps = defaultSnackbarProviderProps(props);
    return react_1.default.createElement(notistack_1.SnackbarProvider, { ...providerProps });
};
exports.default = SnackbarProvider;
